export default "__VITE_ASSET__BMgLNS9b__"